// FOOTER SECTION
export const buildVersion = "Version: ";
export const buildDate = "Stand: ";
